



























import { Fragment } from 'vue-fragment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import AccordionList from '@/components/Global/Accordion/AccordionList.vue';
import Alert from '@/components/Global/Alert.vue';

import Brand from '@/services/Brand';
import { PolicyPacket } from '@/services/PolicyDocuments';

import MmicPolicyItem from './MmicPolicyItem.vue';

@Component({
	components: {
		Alert,
		AccordionList,
		Fragment,
		MmicPolicyItem,
	},
})
export default class MmicPolicyList extends Vue {
	private readonly Brand = Brand;

	@Prop() private packets: any;
	@Prop() private effectiveFrom: any;
	@Prop() private effectiveTo: any;

	private paginate: string[];

	constructor() {
		super();
		console.log('packets', this.packets);
		this.paginate = ['packets'];
	}
}
